import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect, useCallback } from 'react';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 50);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <span className="text-xl md:text-2xl font-heading font-bold text-primary-600">
              韩漫大全
            </span>
            <span className="hidden sm:inline text-xs text-foreground-500 bg-secondary-100 px-2 py-0.5 rounded-full">
              无删减
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/')
                  ? 'bg-primary-500 text-white'
                  : 'text-foreground-700 hover:bg-secondary-100'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/all"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname.startsWith('/category')
                  ? 'bg-primary-500 text-white'
                  : 'text-foreground-700 hover:bg-secondary-100'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/about')
                  ? 'bg-primary-500 text-white'
                  : 'text-foreground-700 hover:bg-secondary-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-48 lg:w-56 h-9 px-4 pl-9 text-sm bg-background-100 border border-background-200 rounded-full focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
            <button className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-user-line text-sm"></i>
            </button>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-secondary-100 transition-colors whitespace-nowrap cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`text-lg ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 shadow-lg">
          <div className="px-4 py-3 space-y-1">
            <Link
              to="/"
              className={`block px-4 py-2.5 rounded-lg text-sm font-medium cursor-pointer ${
                isActive('/') ? 'bg-primary-50 text-primary-700' : 'text-foreground-700 hover:bg-secondary-100'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/all"
              className={`block px-4 py-2.5 rounded-lg text-sm font-medium cursor-pointer ${
                location.pathname.startsWith('/category')
                  ? 'bg-primary-50 text-primary-700'
                  : 'text-foreground-700 hover:bg-secondary-100'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`block px-4 py-2.5 rounded-lg text-sm font-medium cursor-pointer ${
                isActive('/about') ? 'bg-primary-50 text-primary-700' : 'text-foreground-700 hover:bg-secondary-100'
              }`}
            >
              关于我们
            </Link>
            <div className="pt-2">
              <div className="relative">
                <input
                  type="text"
                  placeholder="搜索漫画..."
                  className="w-full h-9 px-4 pl-9 text-sm bg-background-100 border border-background-200 rounded-full focus:outline-none focus:border-primary-300 transition-all"
                />
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              </div>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}